/* ZSportsTech — section-brhero.js
   Scoped to #sc-brhero (Bat Repair · 01 hero). Vanilla JS, namespaced.
   Maps to → assets/section-brhero.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var hero = document.getElementById('sc-brhero');
  if (!hero) return;

  /* ── 1. Optional bg <video> — play only while in view ── */
  var bg  = hero.querySelector('.sc-brhero__bg');
  var vid = hero.querySelector('video.sc-brhero__bg, .sc-brhero__bg video');
  if (vid) {
    vid.setAttribute('playsinline', '');
    vid.muted = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { vid.play().catch(function () {}); }
          else { vid.pause(); }
        });
      }, { threshold: 0.1 }).observe(hero);
    } else { vid.play().catch(function () {}); }
  }

  /* ── 2. Smooth-scroll "Build a quote" → §02 ── */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  hero.querySelectorAll('[data-brhero-scroll]').forEach(function (link) {
    link.addEventListener('click', function (ev) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var target = id && document.getElementById(id);
      if (!target) return;
      ev.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  });
}());
